export const buildResumeFetchApiLink = (
  slug?: string,
  rid?: string | number,
  jobSlug?: string,
  isPassiveRecommendation?: boolean,
) => {
  let link = `/v2/user-resume-detail/${slug ?? ''}`;

  if (rid && slug && !jobSlug) {
    link = `/v2/user-resume-detail/${slug}?rid=${rid}`;
  }

  if (jobSlug && slug) {
    link = `/v2/job/${jobSlug}/user-resume-detail/${slug}`;
    if (rid) {
      link = `/v2/job/${jobSlug}/user-resume-detail/${slug}?rid=${rid}`;
    }
  }

  if (isPassiveRecommendation) {
    link += link.includes('?')
      ? '&isPassiveRecommendation=1'
      : '?isPassiveRecommendation=1';
  }

  return link;
};
